import type { Product as ProductType } from '@/features/basket/types/product';
import { Product } from '@/features/navigation/components/fly-basket/product';
import { clsx } from 'clsx';

interface Props {
  products: ProductType[] | undefined;
  isLoading: boolean;
}

export const ProductsList = ({ products, isLoading }: Props) => {
  return (
    <div
      className={clsx(
        'h-full space-y-m overflow-y-auto pb-3',
        's:h-full s:max-h-small-section-width s:overflow-y-auto s:overflow-x-hidden',
      )}
    >
      {isLoading ? (
        <Product.Skeleton />
      ) : (
        products?.map((product) => (
          <Product product={product} key={product.id} />
        ))
      )}
    </div>
  );
};
